export default __webpack_public_path__ + "static/media/rate_active.e2b5eab2.svg";